<template>
  <div>
    <div class="pos-container h-100vh pb-0 overflow-hidden p-0 bg-pink">
      <!--h-100vh-->

      <!-- <PosHeader /> -->

      <div
        class="d-flex justify-content-between align-items-center padding-header "
      >
        <div class="d-flex align-items-center">
          <img
            v-if="getOrganizationDetails.org_name == 'Empire Cinemas'"
            src="@/assets/img/pos/Empire_logo.jpeg"
            width="50px;padding:20px"
            class="login-brand mx-3"
          />
          <img
            v-else
            src="@/assets/img/logos/Nuvio_Black.png"
            width="135"
            class="login-brand"
          />
          <div class="d-block">
            <!-- <h3
              v-if="getOrganizationDetails.org_name == 'Empire Cinemas'"
              class="mb-0 text-uppercase header-font-main"
            >
              EMPIRE CINEMAS
            </h3> -->
            <!-- <h3 class="mb-0 header-font-main" v-else>
              brij.<span class="text-uppercase">POS</span>
            </h3> -->
            <!-- <p
              class="mb-0 footer-text"
              v-if="getOrganizationDetails.org_name !== 'Empire Cinemas'"
            >
              From Cinema Owners to Cinema Owners
            </p> -->
          </div>
        </div>
        <img
          v-if="getOrganizationDetails"
          :src="getOrganizationDetails.org_logo_url"
          :height="
            String(getOrganizationDetails.org_name)
              .toLowerCase()
              .includes('xanadu')
              ? '90'
              : String(getOrganizationDetails.org_name)
                  .toLowerCase()
                  .includes('europe')
              ? '70'
              : '50'
          "
          :width="
            String(getOrganizationDetails.org_name)
              .toLowerCase()
              .includes('xanadu')
              ? '140'
              : String(getOrganizationDetails.org_name)
                  .toLowerCase()
                  .includes('europe')
              ? '170'
              : '200'
          "
          class="mx-2 d-flex justify-contant-center align-items-center"
        />
        <img
          v-else
          src="@/assets/img/pos/BRIJ (3).svg"
          height="auto"
          width="250px"
          class="mx-2 d-flex justify-contant-center alig-items-center"
        />
      </div>

      <div class="app-login-wrapper bg-pink align-items-center">
        <div class="app-login-box">
          <!--:class="routeName !== '/pos-login' ? '': '' "-->

          <h3 v-if="origin.includes('localhost')" class="text_domain bg-pink">
            Localhost {{ getOrganizationDetails.org_name }}
          </h3>
          <h3 v-else-if="origin.includes('-stg')" class="text_domain bg-pink">
            {{ getOrganizationDetails.org_name }}
          </h3>

          <h3 v-else-if="origin.includes('-dev')" class="text_domain bg-pink">
            {{ getOrganizationDetails.org_name }}
          </h3>

          <!--h3 v-else class="text_domain bg-pink">
                      {{ getOrganizationDetails.org_name }}
                      </h3--->

          <div
            :class="
              getOrganizationDetails.org_name == 'Empire Cinemas'
                ? 'app-login-container pos_log_img'
                : 'app-login-container pos_log_img'
            "
          >
            <!--img
              src="@/assets/img/logos/logo-dark.png"
              width="135"
              class="login-brand"
            /-->

            <form
              @submit.prevent.stop="checkOnlyAuthenticator()"
              class="mb-5"
              ref="posloginform"
            >
              <div class="col-md-7 mx-auto p-3">
                <div class="row">
                  <div class="col-md-12 mb-4">
                    <div
                      class="text-center mb-2 font-weight-bold header_shadow"
                      style="color: #fff"
                    >
                      POS TERMINAL
                    </div>
                    <div class="input-material">
                      <img
                        src="@/assets/img/icons/login-user.png"
                        class="login-icon"
                      />
                      <input
                        type="text"
                        v-model="username"
                        placeholder="Username"
                        required="required"
                        autocomplete="off"
                        autofocus
                        id="dashusername"
                        ref="dashusername"
                        readonly
                        @click="onClickInputHandler('username')"
                        onfocus="this.removeAttribute('readonly');"
                        style="border-radius: 15px"
                      />
                      <!----label>{{ $t("username") }}</label--->
                    </div>
                    <VkeyboardFloat
                      :ID="'dashusername'"
                      :onClickFun="
                        () => {
                          showUsernameVKeyboard = !showUsernameVKeyboard;
                        }
                      "
                    />
                    <Vkeyboard
                      :inputName="'dashusername'"
                      :showOrHide="showUsernameVKeyboard"
                      :initialValue="username"
                      @onChangeEvent="onChangeKeboardData('dashusername')"
                      @onKeyEnter="checkOnlyAuthenticator()"
                      @changeKeyboardInput="username = $event"
                      @onClickClose="
                        () => {
                          showUsernameVKeyboard = false;
                        }
                      "
                    />
                  </div>

                  <div class="col-md-12 mb-4">
                    <div class="input-material">
                      <img
                        src="@/assets/img/icons/login-password.png"
                        class="login-icon"
                      />
                      <img
                        width="18"
                        height="18"
                        @click="togglePassword()"
                        class="show-password-icon"
                        v-if="passwordType == 'password'"
                        src="@/assets/img/icons/show-password.svg"
                      />
                      <img
                        width="18"
                        height="18"
                        @click="togglePassword()"
                        class="show-password-icon"
                        v-if="passwordType == 'text'"
                        src="@/assets/img/icons/hide-password.svg"
                      />
                      <input
                        :type="passwordType"
                        v-model="password"
                        autocomplete="off"
                        placeholder="Password"
                        readonly
                        id="dashpassword"
                        ref="dashpassword"
                        @click="onClickInputHandler('password')"
                        onfocus="this.removeAttribute('readonly');"
                        style="border-radius: 15px"
                      />
                      <!---label>{{ $t("password") }}</label--->
                    </div>
                    <VkeyboardFloat
                      :ID="'dashpassword'"
                      :onClickFun="
                        () => {
                          showPassVKeyboard = !showPassVKeyboard;
                        }
                      "
                    />
                    <Vkeyboard
                      :inputName="'dashpassword'"
                      :initialValue="password"
                      :showOrHide="showPassVKeyboard"
                      :hideTypingInput="true"
                      @onChangeEvent="onChangeKeboardData('dashpassword')"
                      @onKeyEnter="checkOnlyAuthenticator()"
                      @changeKeyboardInput="password = $event"
                      @onClickClose="
                        () => {
                          showPassVKeyboard = false;
                        }
                      "
                    />
                  </div>

                  <div class="col-md-12 mb-4">
                    <div class="row">
                      <div class="col-6 aling-self-center">
                        <button
                          @click.prevent.stop="onClickLoginViaPin()"
                          class="btn-outline-blue-lg w-100 mx-0"
                          type="button"
                        >
                          Login via PIN
                        </button>
                      </div>
                      <div class="col-6">
                        <button
                          class="btn-blue-lg w-100 mx-0"
                          type="submit"
                          ref="loginbutton"
                        >
                          <span class="mr-2">{{ $t("signin") }}</span>
                          <img
                            src="@/assets/img/icons/arrow-right.svg"
                            height="auto"
                            width="15"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <footer class="bg-pink">
        <div
          class="d-flex justify-content-center align-items-center padding-top"
        >
          <div v-if="getOrganizationDetails.org_name != 'Empire Cinemas'">
            <p class="footer-text">
              Made with Love & Passion from India and Switzerland
              <span class="mx-2">|</span> Copyright 2022 by brij cinematic
              services Ltd
            </p>
          </div>
          <div v-else>
            <p class="footer-text">Copyright 2022 by brij</p>
          </div>
        </div>
      </footer>
    </div>

    <b-modal
      hide-footer
      title="Login with PIN"
      id="loginViaPin"
      ref="loginViaPin"
      hide-header
      no-fade
      no-stacking
      @show="focusInput"
    >
      <div class="py-3">
        <div class="pos-mobile-number">
          <div class="row">
            <div class="col-12 mx-auto">
              <div class="row">
                <div class="col-6 mb-4 pr-1">
                  <input
                    @click="onClickInputType('userpin')"
                    maxlength="4"
                    v-model="userpin"
                    type="number"
                    ref="userpin"
                    placeholder="User PIN"
                    class="textPin"
                    @input="checkLength($event)"
                  />
                </div>
                <div class="col-6 mb-4 pl-1">
                  <input
                    @click="onClickInputType('passwordpin')"
                    maxlength="4"
                    v-model="passwordpin"
                    type="password"
                    ref="userpasswordpin"
                    placeholder="Password PIN"
                    class="textPin"
                  />
                </div>
                <div
                  v-for="(value, index) in phone_value"
                  :key="index"
                  class="col-4 mb-2"
                >
                  <button
                    v-if="index == phone_value.length - 1"
                    v-on:click="onSliceNUmber()"
                    class="number"
                  >
                    {{ value.name }}
                  </button>
                  <button
                    v-else-if="value.name != ''"
                    @click="onClickNumber(index)"
                    class="number"
                  >
                    {{ value.name }}
                  </button>
                  <button
                    v-else
                    @click.prevent.stop="clearInput"
                    class="number"
                  >
                    C
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="max-width: 275px" class="mx-auto pt-4">
          <div class="row">
            <div class="col-6">
              <button
                class="btn-outline-blue-lg mx-0 w-100"
                v-on:click="$refs['loginViaPin'].hide()"
              >
                Cancel
              </button>
            </div>
            <div class="col-6">
              <button
                @click.prevent.stop="onFormSubmit()"
                class="btn-blue-lg mx-0 w-100"
              >
                Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <TwoFAModal
      :openModal="showModal"
      @onConfirm="confirmation"
      @onClose="ResetVariable"
      :onlyAuthenticator="onlyAuthenticator"
    ></TwoFAModal>
  </div>
</template>

<script>
  // import languages from "@/helper/Languages";
  // import i18n from "@/plugins/i18n";
  import UserService from "@/services/UserService";
  import MasterService from "@/services/MasterService";
  import PosService from "@/services/PosService";
  import PosHeader from "@/components/Partials/posHeader.vue";
  import TwoFAModal from "@/components/Partials/2FAModal.vue";
  import { backendSocket } from "@/main.js";
  import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
  import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
  import { BASEURL } from "@/config/index";
  import axios from "axios";
  import { getHardwareId, getResourceUsageInfo } from "@/socket.io/init";
  import { EventBus } from "@/main";
  import { CLIENT_NAMES_OBJ } from "@/helper/Role";

  export default {
    components: {
      PosHeader,
      TwoFAModal,
      Vkeyboard,
      VkeyboardFloat,
    },
    data() {
      return {
        showVKeyboard: false,
        showPassVKeyboard: false,
        showUsernameVKeyboard: false,
        origin: window && window.origin ? window.origin : "",
        username: "",
        password: "",
        onlyAuthenticator: false,

        userpin: "",
        passwordpin: "",
        selectedType: "userpin",

        // username: "jaymewada",
        // password: "123456",

        // username: "gogopos",
        // password: "password123"

        phone_value: [
          { name: "1" },
          { name: "2" },
          { name: "3" },
          { name: "4" },
          { name: "5" },
          { name: "6" },
          { name: "7" },
          { name: "8" },
          { name: "9" },
          { name: "+" },
          { name: "0" },
          { name: "<-" },
        ],

        showNotification: false,
        // languages,
        hardware_id: null,
        selectedLanguage: "English",
        showModal: false,
        secretCode: null,
        DeviceUniqueCode: "",
        passwordType: "password",
        cinemasList: [],
        posShiftLog: {
          paymentTypes: [],
          grandTotal: 0,
          cine_include_shift_close: null,
          usl_id: null,
          user_shift_id: null,
        },
      };
    },
    computed: {
      getOrganizationDetails() {
        return this.$store.getters.getOrganizationDetails;
      },
      USE_TIM_INTEGRATION() {
        return this.$store.getters.USE_TIM_INTEGRATION;
      },
    },
    mounted() {
      this.checkUserLoggedInFunction();
      this.DeviceUniqueCode = window.localStorage.getItem("deiviceUniqueCode")
        ? window.localStorage.getItem("deiviceUniqueCode")
        : "";

      if (this.$ipcRenderer) {
        this.$ipcRenderer.send("SET_HOME_PAGE");
        if(this.getOrganizationDetails) {
          this.$ipcRenderer.send("SET_ORG_DETAILS", this.getOrganizationDetails);
        }
      } else {
        console.log("Not running inside Electron");
      }
    },
    methods: {
      focusInput() {
        setTimeout(() => {
          this.$refs["userpin"].focus();
        }, 500);
        this.passwordpin = "";
        this.userpin = "";
      },
      checkLength(event) {
        console.log("coming checkLength", event);
        let stringText = event.target.value;
        console.log("stringText", stringText);
        if (
          stringText &&
          stringText.length > 3 &&
          this.$refs["userpasswordpin"]
        ) {
          this.$refs["userpasswordpin"].focus();
        }
      },
      onChangeKeboardData(refs) {
        if (refs) {
          this.$refs[refs].focus();
          this.$forceUpdate();
        }
      },
      onClickInputHandler(event) {
        if (this.$socket) {
          this.$socket.emit("set_org_details", this.getOrganizationDetails);
        } else {
          console.log("no socket");
        }
        if (this.showUsernameVKeyboard && event == "password") {
          this.showUsernameVKeyboard = false;
          this.showPassVKeyboard = true;
        } else if (this.showUsernameVKeyboard && event == "username") {
          this.showUsernameVKeyboard = false;
          this.showPassVKeyboard = false;
        } else if (this.showPassVKeyboard && event == "username") {
          this.showUsernameVKeyboard = true;
          this.showPassVKeyboard = false;
        } else if (this.showPassVKeyboard && event == "password") {
          this.showUsernameVKeyboard = false;
          this.showPassVKeyboard = false;
        }
      },
      ResetVariable: function(value) {
        this.secretCode = "";
        this.showModal = value;
      },
      onFormSubmit: function() {
        console.log("fsdfsdfs", "fsfsdf", this.userpin, this.passwordpin);
        if (this.userpin && this.passwordpin) {
          this.check2FAIsEnabled();
        }
      },
      confirmation: function(values) {
        if (this.showModal && values) {
          this.secretCode = values;
          this.onPosLogin();
        }
      },
      userShiftStart: async function(shiftUserData, token) {
        this.showLoading();
        // await commit("SET_USER_SHIFT_DETAILS", payload);

        let hardwareMacAddress = window.localStorage.getItem(
          "hardware_mac_address"
        );
        let hardwareId = window.localStorage.getItem("deiviceUniqueCode");
        // functionality remaining
        if (!hardwareId || !hardwareMacAddress) {
          var userAgent = navigator.userAgent.toLowerCase();
          if (userAgent.indexOf(" electron/") > -1) {
            let sys_info = await getResourceUsageInfo();
            const key = Object.keys(sys_info.macAddress)[0];
            hardwareMacAddress = sys_info.macAddress[key].mac;
          }
        }
        // functionality remaining
        let requestPayload = {
          ...this.posShiftLog,
          hardware_id: window.localStorage.getItem("HWUID")
            ? window.localStorage.getItem("HWUID")
            : window.localStorage.getItem("deiviceUniqueCode")
            ? window.localStorage.getItem("deiviceUniqueCode")
            : null,
          hardware_name: window.localStorage.getItem("hardware_name")
            ? window.localStorage.getItem("hardware_name")
            : null,
          hardware_mac_address: window.localStorage.getItem(
            "hardware_mac_address"
          )
            ? window.localStorage.getItem("hardware_mac_address")
            : hardwareMacAddress
            ? hardwareMacAddress
            : null,
        };

        var config = {
          method: "post",
          url: `${BASEURL}/api/pos/pos-user-shift-log`,
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          data: JSON.stringify(requestPayload),
        };

        axios(config)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.posShiftLog = { ...this.posShiftLog, ...data.Records };

              if (data.Records.float_amount) {
                window.localStorage.setItem("FLOAT_AMOUNT_ADDED", "Y");
              } else {
                window.localStorage.setItem("FLOAT_AMOUNT_ADDED", "N");
              }

              if (shiftUserData["cine_include_float_amount"] == "N") {
                window.localStorage.setItem("FLOAT_AMOUNT_ADDED", "Y");
              }
              window.localStorage.setItem(
                "USER_SHIFT_DATA",
                JSON.stringify(this.posShiftLog)
              );
              window.localStorage.setItem(
                "USER_SHIFT_ID",
                this.posShiftLog.usl_id
              );

              if (!data.Records["inserted_new"]) {
                // USE WHEN WE NEED TO FORCE CLOSE SHIFT
                // router.replace({
                //     path: "close-shift"
                // });

                if (
                  shiftUserData["page_name"] &&
                  shiftUserData["page_name"] == "FNB_LOGIN"
                ) {
                  console.log("route to pos-fnb");
                  this.$router.replace({
                    path: "/pos-fnb",
                  });
                } else {
                  this.$router.replace({
                    path: "/pos-booking",
                  });
                }
              } else if (
                shiftUserData["page_name"] &&
                shiftUserData["page_name"] == "FNB_LOGIN"
              ) {
                if (
                  shiftUserData["cine_include_float_amount"] &&
                  shiftUserData["cine_include_float_amount"] == "Y"
                ) {
                  console.log("route to pos-fnb-cash");
                  this.$router.replace({
                    path: "/pos-cash-input",
                    query: { nextRoute: "FNB_LOGIN" },
                  });
                } else {
                  console.log("route to pos-fnb");
                  this.$router.replace({
                    path: "/pos-fnb",
                  });
                }
              } else if (
                shiftUserData["cine_include_float_amount"] &&
                shiftUserData["cine_include_float_amount"] == "Y"
              ) {
                this.$router.replace({
                  path: "/pos-cash-input",
                  query: { nextRoute: "POS_LOGIN" },
                });
              } else {
                this.$router.replace({
                  path: "/pos-booking",
                });
              }
            } else {
            }
          })
          .catch((error) => {})
          .finally(() => {
            setTimeout(() => {
              this.hideLoading();
            }, 1000);
          });
      },
      check2FAIsEnabled: function() {
        this.showLoading();
        let payload = {
          username: this.username || this.userpin,
          password: this.password || this.passwordpin,
        };

        UserService.Check2FAEnabled(payload)
          .then((response) => {
            const { data } = response;

            if (data && data.status) {
              if (data.isEnabled) {
                this.$refs["loginViaPin"].hide();
                this.showModal = !this.showModal;
                // this.$refs["Ref-2fa-Modal"].show();
              } else {
                this.onPosLogin();
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              this.hideLoading();
            }, 1000);
          });
      },
      checkOnlyAuthenticator: function() {
        this.showLoading();
        let payload = {
          username: this.username,
        };
        UserService.CheckOnlyAuthenticatorEnabled(payload)
          .then((resp) => {
            const { data } = resp;
            if (data.status) {
              if (data.isEnabled) {
                this.onlyAuthenticator = true;
                this.showModal = !this.showModal;
              } else {
                if (!this.password) {
                  this.$toasted.show("Please enter your password");
                } else {
                  this.check2FAIsEnabled();
                }
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setTimeout(() => {
              this.hideLoading();
            }, 1000);
          });
      },
      checkUserLoggedInFunction() {
        UserService.checkUserLoggedIn({}).then((response) => {
          const { data } = response;
          let localStorageData = window.localStorage;
          let HashId = localStorage.getItem("JWT_TOKEN");
          let userInfo = localStorageData.getItem("USER_INFO");
          let accessLimitation = localStorageData.getItem("USER_ROLE_NAME");
          if (data.status && HashId) {
            console.log("testing here");
            if (accessLimitation) {
              if (
                accessLimitation == "SUPER" ||
                accessLimitation == "POSONLY"
              ) {
                this.$router.push({
                  path: "pos-booking",
                });
              } else if (accessLimitation == "FNBONLY") {
                this.$router.push({
                  path: "pos-fnb",
                });
              } else {
                this.onLogout();
                this.$toasted.show("Please Login Again!");
              }
            } else {
              console.log("testing here12");
              if (userInfo && userInfo.role_id == 4) {
                this.$router.replace({
                  path: "pos-booking",
                });
              } else if (userInfo && userInfo.role_id == 8) {
                this.$router.replace({
                  path: "pos-fnb",
                });
              } else if (
                userInfo &&
                userInfo.role_id != 8 &&
                userInfo.role_id != 4
              ) {
                this.onLogout();
              }
            }
          } else if (data.errorCode == 409) {
            this.onLogout();
          }
        });
      },
      pingHardware() {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          if (backendSocket && backendSocket.connected) {
            backendSocket.emit("hardware-connected");
          }
        }
      },
      onLogout: function(url) {
        let localStorageData = window.localStorage;
        UserService.removeToken()
          .then((res) => {
            const { data } = res;
            if (data.status == true) {
              window.localStorage.removeItem("JWT_TOKEN");
              window.localStorage.clear();
              this.$router.push({ path: "/" });
            } else {
              window.localStorage.removeItem("JWT_TOKEN");
              window.localStorage.clear();
              this.$router.push({ path: "/" });
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$router.push({ path: "/" });
            this.$toasted.show("Token not removed");
          });
      },
      getOrgnizationLogo: function() {
        PosService.getOrgDetails()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
            } else {
              // this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      onClickLoginViaPin: function() {
        this.$refs["loginViaPin"].show();
      },
      onClickInputType: function(type) {
        this.selectedType = type;
      },
      onClickNumber: function(number) {
        if (this.selectedType == "userpin") {
          if (this.userpin && this.userpin.length > 3) {
            this.onClickInputType("passwordpin");
            this.$refs["userpasswordpin"].focus();
          } else {
            if (number.name == "-") {
              this.userpin = this.userpin.slice(0, -1);
            } else if (number.name == "+") {
              //do nothing
            } else {
              this.userpin += this.phone_value[number].name;
            }
            if (
              this.userpin &&
              this.userpin.length > 3 &&
              this.$refs["userpasswordpin"]
            ) {
              this.onClickInputType("passwordpin");
              this.$refs["userpasswordpin"].focus();
            }
          }
        } else if (this.selectedType == "passwordpin") {
          if (this.passwordpin && this.passwordpin.length > 3) return;
          if (number.name == "-") {
            this.passwordpin = this.passwordpin.slice(0, -1);
          } else if (number.name == "+") {
            //do nothing
          } else {
            this.passwordpin += this.phone_value[number].name;
          }
        }
      },
      onSliceNUmber: function() {
        if (this.selectedType == "userpin") {
          if (this.userpin.length > 0) {
            this.userpin = this.userpin.slice(0, -1);
          }
          if (this.userpin.length == 0) {
            this.userpin = "";
          }
        } else if (this.selectedType == "passwordpin") {
          if (this.passwordpin.length > 0) {
            this.passwordpin = this.passwordpin.slice(0, -1);
          }
          if (this.passwordpin.length == 0) {
            this.passwordpin = "";
          }
        }
      },
      clearInput: function() {
        if (this.selectedType == "userpin") {
          this.userpin = "";
        } else if (this.selectedType == "passwordpin") {
          this.passwordpin = "";
        }
      },
      getAllCinemas: function() {
        MasterService.GetAllCinema({})
          .then((response) => {
            this.cinemasList = [];
            const { data } = response;
            if (
              data &&
              data.status &&
              data.Records &&
              data.Records.length > 0
            ) {
              this.cinemasList = [...data.Records];
            } else {
              this.$toasted.show("Something went wrong on cinema fetch");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      onPosLogin: function() {
        window.localStorage.setItem("cacheMode", "Y");
        if (
          (this.username && String(this.username).length == 0) ||
          (this.userpin && String(this.userpin).length == 0)
        ) {
          this.$toasted.show("Please provide username");
          return;
        } else if (
          (this.password &&
            String(this.password).length == 0 &&
            !this.onlyAuthenticator) ||
          (this.passwordpin && String(this.passwordpin).length == 0)
        ) {
          this.$toasted.show("Please provide password");
          return;
        } else {
          this.showLoading();
          let payload = {
            username: this.username || this.userpin,
            password: this.password || this.passwordpin,
            onlyAuthenticator: this.onlyAuthenticator,
          };
          let checkAccess = "";
          if (this.secretCode && this.secretCode.length > 0) {
            payload.secretCode = this.secretCode;
          }
          if (this.hardware_id) {
            payload["hardware_id"] = this.hardware_id;
          }
          UserService.LoginUser(payload)
            .then(async (response) => {
              const { data } = response;
              if (data.status) {
                this.secretCode = "";
                this.showModal = false;
                this.$refs["loginViaPin"].hide();
                let finalObj = {};
                let PromiseArray = this.usersArray.map((x) => {
                  finalObj[x] = data.data.user[x] || null;
                });
                // console.log("finalObj", finalObj);
                await Promise.all(PromiseArray);

                this.pingHardware();

                //CHECK LIMITATION ON ACCESS
                checkAccess = this.checkPosAccess(data.data.user);
                if (!checkAccess && [4, 8].includes(data.data.user.role_id)) {
                  this.$toasted.show("User has No Access!");
                } else if (data.data.user && data.data.user.shift_id) {
                  window.localStorage.setItem(
                    "USER_INFO",
                    finalObj ? JSON.stringify(finalObj) : {}
                  );

                  window.localStorage.setItem(
                    "DFLT_USINFO",
                    finalObj ? JSON.stringify(finalObj) : {}
                  );

                  // HASH TOKEN KEY: BR-BRIJ HS: HASH ID =BRHSID

                  // this.$store.dispatch("onSetAndSendLog", {
                  //   cinema_id: finalObj.cinema_id,
                  //   user_id: finalObj.user_id,
                  //   action: "POS User Logged In",
                  //   page_name: "POS LOGIN",
                  //   api_name: window.location.hash,
                  // });
                  // BRLF: BRIJ LOGIN FROM
                  window.localStorage.setItem("JWT_TOKEN", data.data.token);

                  if (
                    data.hasOwnProperty("cinema_reponse") &&
                    data.cinema_reponse &&
                    data.cinema_reponse.length > 0 &&
                    data.cinema_reponse[0].cinema_id &&
                    ["4", "8"].includes(String(data.data.user.role_id))
                  ) {
                    window.localStorage.setItem(
                      "cinema_id",
                      data.cinema_reponse[0].cinema_id
                    );

                    if (data.cinema_reponse[0].cinema_id) {
                      this.$store.dispatch("fetchCinemaSpecificSettings", {
                        cinema_id: data.cinema_reponse[0].cinema_id,
                      });
                    }
                  } else if (
                    ["4", "8"].includes(String(data.data.user.role_id))
                  ) {
                    window.localStorage.setItem(
                      "cinema_id",
                      finalObj.cinema_id
                    );

                    if (finalObj.cinema_id) {
                      this.$store.dispatch("fetchCinemaSpecificSettings", {
                        cinema_id: finalObj.cinema_id,
                      });
                    }
                  }

                  window.localStorage.setItem(
                    "IS_SHIFT_CLOSE",
                    data.data.user.cine_include_shift_close
                  );
                  // BRIJ CINE FLOAT AMOUT

                  // POS USER ACCESS LIMITATIONS POS/FNB
                  // POSONLY FNBONLY SUPER
                  window.localStorage.setItem("USER_ROLE_NAME", checkAccess);

                  window.localStorage.setItem(
                    "IS_INCLUDE_FLOAT_AMOUNT",
                    data.data.user["cine_include_float_amount"]
                  );

                  if (checkAccess == "FNBONLY") {
                    window.localStorage.setItem("isBOCalculator", false);
                    await this.userShiftStart(
                      {
                        usl_id: data.data.user.user_id,
                        user_shift_id: data.data.user.shift_id,
                        cine_include_shift_close:
                          data.data.user.cine_include_shift_close,
                        cine_include_float_amount:
                          data.data.user.cine_include_float_amount,
                        page_name: "FNB_LOGIN",
                      },
                      data.data.token
                    );
                  } else {
                    window.localStorage.setItem("isBOCalculator", true);
                    await this.userShiftStart(
                      {
                        usl_id: data.data.user.user_id,
                        user_shift_id: data.data.user.shift_id,
                        cine_include_shift_close:
                          data.data.user.cine_include_shift_close,
                        cine_include_float_amount:
                          data.data.user.cine_include_float_amount,
                      },
                      data.data.token
                    );
                  }
                  console.log("this.hardware_id", this.hardware_id);

                  var userAgent = navigator.userAgent.toLowerCase();
                  if (userAgent.indexOf(" electron/") > -1) {
                    if (backendSocket && backendSocket.connected) {
                      backendSocket.emit("on_user_login", {
                        user: data.data.user,
                        hardware_id: this.hardware_id,
                      });
                    }
                  }
                  // console.log(data.data.user, "data.userthing");

                  // this.$store.dispatch("onUserLogin", data.data.user);

                  // functionality remaining
                  if (!this.authorizeClient(CLIENT_NAMES_OBJ.no_login_print)) {
                    let loginData = {
                      cine_name: "",
                      first_name: "",
                      last_name: "",
                      role_name: "",
                      up_employee_code: "",
                      current_login_date_time: "",
                      float_amount: "",
                    };
                    if (data.data.user) {
                      Object.keys(loginData).forEach((userKeys) => {
                        loginData[userKeys] = data.data.user[userKeys];
                      });
                    }
                    console.log(loginData, "loginData");
                    setTimeout(() => {
                      if (this.$socket) {
                        this.$socket.emit("on_print_ticket", {
                          cinema_id: data.data.user.cinema_id,
                          baseurl: BASEURL,
                          ttype: "empire-login-ticket",
                          openDrawer: "N",
                          loginDateTime: JSON.stringify(loginData),
                        });
                      }
                    }, 2000);
                  }

                  if (this.USE_TIM_INTEGRATION == "Y") {
                    this.initTimMachine();
                  }

                  this.sendAuditLogs({
                    cinema_id: finalObj.cinema_id,
                    user_id: finalObj.user_id,
                    action: `POS User Logged In - (${checkAccess})`,
                    page_name: "POS LOGIN",
                    api_name: window.location.hash,
                  });
                } else if (data.data.user.role_name == "Kitchen Manager") {
                  window.localStorage.setItem(
                    "USER_INFO",
                    finalObj ? JSON.stringify(finalObj) : {}
                  );

                  window.localStorage.setItem(
                    "DFLT_USINFO",
                    finalObj ? JSON.stringify(finalObj) : {}
                  );

                  window.localStorage.setItem("JWT_TOKEN", data.data.token);

                  window.localStorage.setItem("USER_ROLE_NAME", checkAccess);

                  this.sendAuditLogs({
                    cinema_id: finalObj.cinema_id,
                    user_id: finalObj.user_id,
                    action: `Kitchen User Logged In - (${checkAccess})`,
                    page_name: "Kitchen Display",
                    api_name: window.location.hash,
                  });

                  if (data.data.user.order_pickup_access_only == "Y") {
                    console.log("route to kitchen-pickup");
                    this.$router.push({
                      path: "/kitchen-pickup",
                    });
                  } else {
                    console.log("route to kitchen-sales");
                    this.$router.push({
                      path: "/kitchen-sales",
                    });
                  }
                } else {
                  this.$toasted.show(
                    "Sorry You Are Not A Pos Operator Or Your Shift is Not Created"
                  );
                }
                /**
                 * START SHIFT
                 */
              } else {
                this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
              }
            })
            .catch((error) => {
              this.$refs["loginViaPin"].hide();
              this.$toasted.show(error);
            })
            .finally(() => {
              setTimeout(() => {
                this.hideLoading();
              }, 1000);
            });
        }
      },
      checkPosAccess(user) {
        let status = "";
        if ([4, 8].includes(user.role_id)) {
          if (user.pos_access == "Y" && user.fnb_access == "Y") {
            status = "SUPER";
          } else if (user.pos_access == "Y" && user.fnb_access == "N") {
            status = "POSONLY";
          } else if (user.pos_access == "N" && user.fnb_access == "Y") {
            status = "FNBONLY";
          }
        } else if ([13].includes(user.role_id)) {
          if (user.order_pickup_access_only == "Y") {
            status = "PICKUPKITCHEN";
          } else {
            status = "KITCHENUSER";
          }
        }
        return status;
      },
      initTimMachine() {
        let configObj = {
          pos_id: "",
          ecr_user_id: null,
          ecr_ip_address: "",
          ecr_port: "",
        };
        if (
          !localStorage.getItem("ECR_INIT_STATUS") &&
          this.$cookie.get("ECR_INFO")
        ) {
          let ECR_INFO = JSON.parse(this.$cookie.get("ECR_INFO"));
          Object.keys(ECR_INFO).map((x) => {
            configObj[x] = ECR_INFO[x];
          });

          if (configObj.ecr_ip_address && configObj.ecr_port) {
            setTimeout((z) => {
              let obj = {
                EventBus: EventBus,
                IPADDRESS: configObj.ecr_ip_address,
                PORT: configObj.ecr_port,
                USERID: configObj.ecr_user_id,
                POSID: configObj.pos_id,
                INTEGRATIONID: "367fcd48-f574-4119-960c-d1ebb00f9a97",
              };
              if (typeof initTimApi == "function") {
                initTimApi(obj);
                localStorage.setItem("ECR_INIT_STATUS", true);
              }
            }, 500);
          } else {
            localStorage.setItem("ECR_INIT_STATUS", false);
          }
        } else {
          console.log("ECR Settings not found");
        }
      },
      openNotificaton: function() {},
      /* eslint-disable */
      changeLanguage: function({ language, title }) {},
      togglePassword() {
        if (this.passwordType == "password") {
          this.passwordType = "text";
        } else {
          this.passwordType = "password";
        }
      },
    },
  };
</script>

<style scoped>
  .show-password-icon,
  .hide-password-icon {
    top: 11px;
    right: 50px;
    position: absolute;
  }

  .app-login-container .input-material input::placeholder {
    color: var(--blue);
    font-weight: 500;
  }

  .bg-login {
    background-color: #f7fbfb !important;
  }

  .padding-header {
    padding: 20px;
  }

  .header-font-main {
    color: #122c6a;
    font-weight: bold;
  }

  .footer-text {
    color: #122c6a;
    font-weight: 500;
  }

  .height-pos {
    height: 60vh !important;
  }

  .bg-pink {
    background-color: #fef2e8 !important;
  }

  .text_domain {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding-bottom: 20px;
  }

  .textPin:not(:placeholder-shown) {
    font-size: 17px;
    letter-spacing: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/posLogin.vue